import React from 'react'
import { useDraggableSheet } from '../../../helpers/hooks';
import './ModalMessage.scss';

const ModalMessage = ({ children, onClose, style, withoutMaxHeight=false }) => {
    const {
        // dragOffset,
        // dragging,
        sheetStyle,
        overlayHandlers
    } = useDraggableSheet({ onClose });

    return (
        <div
            className={`about-creator`}
            {...overlayHandlers}
        >
            <div
                    className={`${withoutMaxHeight ? 'sheetwithoutmaxheight' : 'sheet'} p-24 `}
                    style={{ ...sheetStyle, ...style }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="about-creator-container">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default ModalMessage